
import { ref, computed, onMounted, onBeforeUnmount, defineComponent } from 'vue'

import SparkDocsBanner from '@/common/components/banners/SparkDocsBanner/index.vue'
import SparkDocsBannerSecond from '@/common/components/banners/SparkDocsBannerSecond/index.vue'
import SparkDocsBannerThird from '@/common/components/banners/SparkDocsBannerThird/index.vue'

const SLIDES_COUNT = 3
const SLIDES_SWITCH_DELAY = 10 * 1000 //10s
const SLIDE_GAP_PX = 16

export default defineComponent({
    components: {
        'spark-docs-banner': SparkDocsBanner,
        'spark-docs-banner-second': SparkDocsBannerSecond,
        'spark-docs-banner-third': SparkDocsBannerThird,
    },
    emits: ['banner-clicked'],
    setup(_, { emit }) {
        const current_slide = ref<number>(0)

        let interval: ReturnType<typeof setInterval> | null = null

        const nextSlide = () => {
            if (current_slide.value === SLIDES_COUNT) {
                current_slide.value = 1
            } else {
                current_slide.value = (current_slide.value + 1) % SLIDES_COUNT
            }
        }

        const startAutoSlide = () => {
            interval = setInterval(() => {
                nextSlide()
            }, SLIDES_SWITCH_DELAY)
        }

        const stopAutoSlide = () => {
            if (interval) {
                clearInterval(interval)
                interval = null
            }
        }

        const onBannerClicked = () => {
            emit('banner-clicked')
        }

        onMounted(() => {
            startAutoSlide()
        })

        onBeforeUnmount(() => {
            stopAutoSlide()
        })

        const containerStyle = computed(() => {
            return {
                gap: `${SLIDE_GAP_PX}px`,
                transform: `translateX(calc(-${current_slide.value * 100}% - ${current_slide.value * SLIDE_GAP_PX}px))`
            }
        })

        return {
            stopAutoSlide,
            startAutoSlide,
            onBannerClicked,
            containerStyle
        }
    }
})
